import React, { useState, useEffect } from 'react';
import DataTable from '../../components/DataTable';
import { expensesAPI } from '../../lib/api';

const Expenses = () => {
  const [expenses, setExpenses] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchExpenses = async () => {
    setLoading(true);
    try {
      const response = await expensesAPI.getAll();
      setExpenses(response.data);
    } catch (error) {
      console.error('Error fetching expenses:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchExpenses();
  }, []);

  const columns = [
    { key: 'description', label: 'Description' },
    { key: 'category', label: 'Category' },
    { key: 'amount', label: 'Amount', type: 'currency' },
    { key: 'vendor', label: 'Vendor' },
    { key: 'date', label: 'Date', type: 'date' },
    { key: 'status', label: 'Status', type: 'status' },
  ];

  const formFields = [
    { name: 'description', label: 'Description', required: true, placeholder: 'Expense description' },
    { name: 'amount', label: 'Amount', type: 'number', required: true, defaultValue: 0 },
    { name: 'category', label: 'Category', placeholder: 'e.g., Operations, Marketing' },
    { name: 'vendor', label: 'Vendor', placeholder: 'Vendor or supplier name' },
    { name: 'date', label: 'Date', type: 'date' },
    {
      name: 'status',
      label: 'Status',
      type: 'select',
      defaultValue: 'pending',
      options: [
        { value: 'pending', label: 'Pending' },
        { value: 'approved', label: 'Approved' },
        { value: 'rejected', label: 'Rejected' },
        { value: 'paid', label: 'Paid' },
      ],
    },
  ];

  const handleAdd = async (data) => {
    await expensesAPI.create(data);
    fetchExpenses();
  };

  const handleEdit = async (id, data) => {
    await expensesAPI.update(id, data);
    fetchExpenses();
  };

  const handleDelete = async (id) => {
    await expensesAPI.delete(id);
    fetchExpenses();
  };

  return (
    <DataTable
      title="Expenses"
      description="Track and manage expenses"
      data={expenses}
      columns={columns}
      formFields={formFields}
      onAdd={handleAdd}
      onEdit={handleEdit}
      onDelete={handleDelete}
      loading={loading}
      searchField="description"
    />
  );
};

export default Expenses;
